import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectMamGroupMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_MAM_GROUP_MESSAGE);
        this.subAccounts = [];
    }
}
export class MamSubAccount {
}
